<template>
  <div style="background-color: #eee">
    <div v-if="loading" class="text-xs-center py-4">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
      <div class="text-xs-right">
        <v-btn small @click="showAdd" dark color="green">
          <em class="fa fa-plus mr-1" />ADD Service</v-btn
        >
        <v-divider></v-divider>
      </div>
      <div v-if="services.length">
        <div v-for="(item, k) in filterServices" :key="k">
          <div style="position: relative">
            <div style="position: absolute; right: 5px; top: 5px">
              <v-btn @click="showEdit(item)" class="ma-0" icon>
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn @click="deleteItem(item, k)" class="ma-0" icon>
                <v-icon>delete</v-icon>
              </v-btn>
            </div>
            <v-layout row wrap class="ma-0 pa-3">
              <v-flex xs2>
                <div
                  style="
                    background-color: white;
                    height: 100px;
                    border: 1px solid #eee;
                    position: relative;
                    display: grid;
                  "
                >
                  <v-img contain :src="item.photourl"></v-img>
                </div>
              </v-flex>
              <v-flex xs10 class="px-2">
                <div style="font-size: 19px; font-weight: 600">{{ item.name }}</div>
                <a href="javascript:void(0);" @click="tab = 'en'">EN</a> |
                <a href="javascript:void(0);" @click="tab = 'th'">TH</a>
                <div style="font-size: small" class="mb-3" v-if="tab == 'en'">
                  {{ item.description ? item.description : '-' }}
                </div>
                <div style="font-size: small" class="mb-3" v-else>
                  {{ item.description_th ? item.description_th : '-' }}
                </div>

                <v-layout row wrap class="ma-0">
                  <v-flex xs6>
                    <div style="font-size: small">Points</div>
                    <div style="font-weight: 500">
                      {{ item.points ? item.points : '-' }}
                    </div></v-flex
                  >
                  <v-flex xs6>
                    <div style="font-size: small">Spend time</div>
                    <div style="font-weight: 500">
                      {{
                        moment
                          .utc(
                            moment.duration(parseInt(item.spend_time), 'minutes').asMilliseconds()
                          )
                          .format('HH:mm')
                      }}
                      Hour
                    </div></v-flex
                  >
                  <v-flex class="mt-2" xs12
                    ><div style="font-size: small">Available days</div>
                    <div style="font-weight: 500">
                      <available-table
                        v-model="item.available"
                        :spendtime="item.spend_time"
                      ></available-table></div
                  ></v-flex>
                  <!-- <v-flex class="mt-2" xs6>
                    <div style="font-size: small">Available time</div>
                    <div v-if="item.available_time" style="font-weight: 500">
                      {{ item.available_time.replace(',', ' - ') }}
                    </div>
                  </v-flex> -->
                </v-layout>
              </v-flex>
            </v-layout>
          </div>
          <v-divider></v-divider>
        </div>
      </div>
      <div v-else>
        <div color="#eee" class="py-4">
          <div class="text-xs-center" style="font-weight: 500; color: grey; font-size: 21px">
            ไม่พบ Service
          </div>
        </div>
      </div>
    </div>

    <v-dialog v-if="modalAdd" v-model="modalAdd" persistent width="650px">
      <EditService
        v-if="modalAdd"
        @close="modalAdd = false"
        @oncreate="onCreateProduct"
        @onedit="onEditProduct"
        :editdata="editdata"
        :edittype="edittype"
      ></EditService>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import EditService from './EditService.vue'
import moment from 'moment'
import AvailableTable from './AvailableTable'
export default {
  props: {
    category_id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      services: [],
      loading: true,
      modalAdd: false,
      edittype: '',
      editdata: '',
      tab: 'en'
    }
  },
  computed: {
    moment() {
      return moment
    },
    ...mapGetters(['selectedBot']),
    filterServices() {
      const priorityServices = [
        {
          name: 'Cleaning',
          id: '8',
          services: {
            'General cleaning (less than 80 sq.m.)': 0,
            'General cleaning (more than 80 sq.m.)': 1,
            'General cleaning (more than 100 sqm.)': 2,
            'Deep cleaning (less than 80 sq.m.)': 3,
            'Deep cleaning (more than 80 sq.m.)': 4,
            'Deep cleaning (more than 100 sq.m.)': 5
          }
        }
      ]

      const priority =
        this.category_id != null ? priorityServices.find((el) => el.id == this.category_id) : null
      return this.services.sort((a, b) => {
        if (priority) {
          const a_name = a.name ? a.name.trim() : '',
            b_name = b.name ? b.name.trim() : ''
          if (
            priority.services.hasOwnProperty(a_name) &&
            priority.services.hasOwnProperty(b_name)
          ) {
            if (priority.services[a_name] > priority.services[b_name]) return 1
            else if (priority.services[a_name] < priority.services[b_name]) return -1
            else return 0
          }
        }
        if (a.points < b.points) return -1
        else if (a.points > b.points) return 1
        else return 0
      })
    }
  },
  components: {
    EditService,
    AvailableTable
  },
  async mounted() {
    await this.getService()
    this.loading = false
  },
  methods: {
    deleteItem(item, k) {
      this.$swal
        .fire({
          text: 'ต้องการลบ Service นี้หรือไม่?',
          showCancelButton: true
          //   reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              product_id: item.id
            }
            api.deletemjdservicesproduct(data, (err, response) => {
              if (response.responsecode == 200) {
                this.services.splice(k, 1)
              }
            })
          }
        })
    },
    showEdit(item) {
      this.edittype = 'edit'
      this.editdata = item
      this.modalAdd = true
    },
    async onCreateProduct() {
      this.modalAdd = false
      this.loading = true
      await this.getService()
      this.loading = false
    },
    async onEditProduct() {
      this.modalAdd = false
      this.loading = true
      await this.getService()
      this.loading = false
    },
    showAdd() {
      this.edittype = 'create'
      this.editdata = { category_id: this.category_id }
      this.modalAdd = true
    },
    getService() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          category_id: this.category_id
        }
        api.getmjdservicesproduct(data, (err, response) => {
          if (response.responsecode == 200) {
            this.services = response.data
            resolve()
            // this.allservices.push(response.dat)
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/mjd/ServiceByCategory.vue